import type {ErrorComponentProps} from "@tanstack/react-router";
import {GenericErrorComponent} from "~/components/genericErrorComponent";
import {useIntellsysDevtoolsConfiguration} from "~/contexts/intellsysDevtoolsClientContext";

export function DefaultErrorComponent({info, error, reset}: ErrorComponentProps) {
    const intellsysDevtoolsConfiguration = useIntellsysDevtoolsConfiguration();

    if (intellsysDevtoolsConfiguration.insaneLogs.tanstackRouterDebugging === true) {
        console.info(+new Date(), "tanstackRouterDebugging", "?", "errorComponent");
    }

    if (intellsysDevtoolsConfiguration.insaneLogs.errorComponentLogs === true) {
        console.groupCollapsed(+new Date(), "errorComponentLogs", "?", "errorComponent");
        console.log("error", error);
        console.log("info", info);
        console.log("reset", reset);
        console.groupEnd();
    }

    return <GenericErrorComponent error={error.message} />;
}
